import React, {useEffect} from "react";
import "../CSS/styles.css";
import nat from "../../assets/nat.png";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Slider6 = () => {
  useEffect(() => {
        AOS.init({
          duration: 1000,
          once: false,
        });
      }, []);
  return (
    <div className="container-fluid mt-lg-5 mt-2 px-0" data-aos="fade-down">
      <div className="row pt-4 justify-content-center">
        <div className="col-12">
          <div className="image-gradient-wrap3">
            <img src={nat} alt="2" className="img-fluid" />
            <div className="gradient-over3"></div>
            <div className="over-cont3 d-flex flex-column align-items-center justify-content-center">
              <h1 className="fw-bolder mt-3 inter h0 mb-0 text-center">National Security Infrastructure <br /> Assessment </h1>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Slider6
